import { reactive } from 'vue';
import { createLocalStorage } from "@/lib/storage";
import {
    LOGIN_CONE_HEALTH,
    LOGIN_EMSMC,
    REQUEST_AUTHORIZE_URL_EMSMC,
    REQUEST_AUTHORIZE_URL_CONE_HEALTH,
    TENANT_CONE_HEALTH,
    TENANT_NAME_CONE_HEALTH,
    TENANT_NAME_EMSMC,
} from "@/lib/azure";

const storage = createLocalStorage('azure-ad');

export const state = reactive(storage.get('data', {
    key: null,
    name: null,
    loginUrl: null,
    authorizeUrl: null,
}));

export function setupAzureConfig(data) {
    state.key = data.tenant;

    let isEmsTenant = state.key !== TENANT_CONE_HEALTH;

    state.name = isEmsTenant ? TENANT_NAME_EMSMC : TENANT_NAME_CONE_HEALTH;
    state.loginUrl = isEmsTenant ? LOGIN_EMSMC : LOGIN_CONE_HEALTH;
    state.authorizeUrl = isEmsTenant ? REQUEST_AUTHORIZE_URL_EMSMC : REQUEST_AUTHORIZE_URL_CONE_HEALTH;

    saveChanges();
}

function saveChanges() {
    storage.set('data', state);
}